import choc from "../assets/images/choc-chip.jpg";
import birthday from "../assets/images/birthday.jpg";
import brownie from "../assets/images/brownie.jpg";
import carrot from "../assets/images/carrot.jpg";
import chocolate from "../assets/images/chocolate.jpg";
import lemon from "../assets/images/lemon.jpg";
import maple from "../assets/images/maple.jpg";
import raisin from "../assets/images/raisin.jpg";
import red from "../assets/images/red-velvet.jpg";
import toffee from "../assets/images/toffee.jpg";
import vanilla from "../assets/images/vanilla.jpg";
import white from "../assets/images/white-choc.jpg";

const data = {
  products: [
    {
      id: "1",
      image: choc,
      title: "M&M Chocolate Chip",
      price: "1.00",
      type: "cookie",
    },
    {
      id: "2",
      image: toffee,
      title: "English Tofee",
      price: "1.00",
      type: "cookie",
    },
    {
      id: "3",
      image: raisin,
      title: "Oatmeal Raisin",
      price: "1.00",
      type: "cookie",
    },
    {
      id: "4",
      image: white,
      title: "White Chcolate Macademia Nut",
      price: "1.00",
      type: "cookie",
    },
    {
      id: "5",
      image: chocolate,
      title: "Chocolate",
      price: "2.00",
      type: "cupcake",
    },
    {
      id: "6",
      image: red,
      title: "Red Velvet",
      price: "2.00",
      type: "cupcake",
    },
    {
      id: "7",
      image: vanilla,
      title: "Vanilla",
      price: "2.00",
      type: "cupcake",
    },
    {
      id: "8",
      image: carrot,
      title: "Carrot",
      price: "2.00",
      type: "cupcake",
    },
    {
      id: "9",
      image: maple,
      title: "Maple",
      price: "2.00",
      type: "cupcake",
    },
    {
      id: "10",
      image: brownie,
      title: "Brownie",
      price: "2.50",
      type: "confection",
    },
    {
      id: "11",
      image: lemon,
      title: "Lemon Square",
      price: "2.50",
      type: "confection",
    },
    {
      id: "12",
      image: birthday,
      title: "Birthday Blondie",
      price: "1.50",
      type: "confection",
    },
  ],
};
export default data;
